import PropTypes from 'prop-types';

const InstructorName = (props) => {
  const { instructor } = props;

  return instructor.name;
};

InstructorName.propTypes = {
  instructor: PropTypes.object.isRequired,
};

export default InstructorName;
